import React, { ElementType } from 'react';
import { typography } from '../../settings';
import { Text } from './Text';

export interface SubtleTextProps {
    as?: ElementType<React.HTMLAttributes<HTMLElement>>;
    children: React.ReactNode;
    size?: 'small' | 'regular';
}

export function SubtleText({ size = 'small', ...rest }: SubtleTextProps) {
    return <Text {...rest} color="fiftyFirstShade" size={typography.paragraphFontSizes[size]} />;
}
